<template>
  <div class="tf">
    <Breadcrumbs main="Рейтинг" title="Новый сезон BPL"/>

    <div class="container-fluid tf-wrap">
      <div class="cb-card">
        <div class="cb-card__head">
          <span class="cb-card__icon"><i class="fa fa-trophy"></i></span>
          <div>
            <h3 class="cb-card__title">Новый сезон BPL</h3>
            <p class="cb-card__sub">Сезон появится в списке на странице сезонного рейтинга</p>
          </div>
        </div>

        <form class="cb-card__body" @submit.prevent="createBplSeasonal">
          <label class="cb-label" for="bpl-season-name">Название сезона</label>
          <input id="bpl-season-name"
                 v-model="name"
                 type="text"
                 class="cb-input"
                 placeholder="Например: BPL Season 14"
                 autocomplete="off"/>
          <div class="cb-hint">Название видно администраторам при выборе сезона.</div>

          <div v-if="message" class="cb-alert" :class="isError ? 'cb-alert--error' : 'cb-alert--ok'">
            <i class="fa" :class="isError ? 'fa-exclamation-triangle' : 'fa-check'"></i>
            {{ message }}
          </div>

          <div class="cb-card__foot">
            <router-link :to="{ name: 'bpl-season' }" class="cb-btn-ghost">К сезонному рейтингу</router-link>
            <button type="submit" class="cb-btn-primary" :disabled="!isValid">
              <i class="fa fa-plus"></i> Создать сезон
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import api from "@/api/api";

export default {
  name: "CreateBplSeasonal",
  components: {},
  created() {
  },
  data() {
    return {
      name: "",
      message: "",
      isError: false,
    }
  },
  computed: {
    isValid() {
      return Boolean((this.name || '').trim());
    },
  },
  methods: {
    async createBplSeasonal() {
      if (!this.isValid) return;

      try {
        const res = await api.rating.createBplSeasonal({name: this.name});
        this.name = ""
        if (res.status === 201) {
          this.message = "Сезон успешно создан";
          this.isError = false;
          setTimeout(() => {
            this.message = "";
          }, 5000);
        }
      } catch (error) {
        this.message = error.response?.data?.message || error?.message || "";
        this.isError = true;
        setTimeout(() => {
          this.message = "";
        }, 5000);
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import "~@/assets/scss/tournament-form-tokens";

.tf {
  @include tf-tokens-light;

  padding-bottom: 40px;
}

body.dark-only .tf {
  @include tf-tokens-dark;
}

.cb-card {
  max-width: 560px;
  background: var(--tf-bg);
  border: 1px solid var(--tf-border-strong);
  border-radius: var(--tf-radius);
  box-shadow: var(--tf-shadow-md);
  overflow: hidden;

  &__head {
    display: flex;
    align-items: center;
    gap: 12px;
    padding: 16px 20px;
    border-bottom: 1px solid var(--tf-border);
  }

  &__icon {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 34px;
    height: 34px;
    border-radius: 10px;
    background: var(--tf-primary-soft);
    color: var(--tf-primary);
  }

  &__title {
    margin: 0;
    font-size: 15px;
    font-weight: 700;
    color: var(--tf-text-strong);
  }

  &__sub {
    margin: 2px 0 0;
    font-size: 12px;
    color: var(--tf-muted);
  }

  &__body { padding: 20px; }

  &__foot {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    gap: 8px;
    margin: 20px -20px -20px;
    padding: 14px 20px;
    border-top: 1px solid var(--tf-border);
    background: var(--tf-soft);
  }
}

.cb-label {
  display: block;
  margin-bottom: 5px;
  font-size: 12px;
  font-weight: 600;
  color: var(--tf-text);
}

.cb-input {
  width: 100%;
  height: 40px;
  padding: 0 12px;
  border: 1px solid var(--tf-border-strong);
  border-radius: 10px;
  background: var(--tf-bg);
  color: var(--tf-text);
  font-size: 13.5px;
  outline: none;
  transition: border-color .16s ease, box-shadow .16s ease;

  &::placeholder { color: var(--tf-muted); }

  &:focus {
    border-color: var(--tf-primary);
    box-shadow: 0 0 0 3px var(--tf-primary-soft);
  }
}

.cb-hint {
  margin-top: 6px;
  font-size: 11.5px;
  color: var(--tf-muted);
}

.cb-alert {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-top: 14px;
  padding: 10px 14px;
  border-radius: 10px;
  font-size: 12.5px;
  font-weight: 500;

  &--ok { background: var(--tf-ok-soft); color: #1f8a30; }

  &--error { background: var(--tf-danger-soft); color: var(--tf-danger); }
}

.cb-btn-primary,
.cb-btn-ghost {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  height: 38px;
  padding: 0 16px;
  border-radius: 10px;
  font-size: 13px;
  font-weight: 600;
  text-decoration: none !important;
  transition: all .16s ease;
}

.cb-btn-primary {
  border: 0;
  background: var(--tf-primary);
  color: #fff;

  &:hover:not(:disabled) { filter: brightness(1.07); }

  &:disabled { opacity: .55; cursor: not-allowed; }
}

.cb-btn-ghost {
  border: 1px solid var(--tf-border-strong);
  background: var(--tf-bg);
  color: var(--tf-text) !important;
  font-weight: 500;

  &:hover { border-color: var(--tf-primary); color: var(--tf-primary) !important; }
}
</style>
